import { useQuery, useMutation, useQueryClient } from 'react-query'
import axios from 'axios'

export const useProcedures = (filters = {}) => {
  const queryClient = useQueryClient()

  const query = useQuery(
    ['procedimientos', filters],
    async () => {
      const params = new URLSearchParams()
      
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, value)
        }
      })

      const response = await axios.get(`/procedimientos?${params.toString()}`)
      return response.data
    },
    {
      keepPreviousData: true,
      staleTime: 2 * 60 * 1000,
    }
  )

  return {
    procedimientos: query.data?.procedimientos || [],
    pagination: query.data?.pagination,
    loading: query.isLoading,
    error: query.error,
    refetch: query.refetch
  }
}

export const useProcedure = (id) => {
  const query = useQuery(
    ['procedimiento', id],
    async () => {
      const response = await axios.get(`/procedimientos/${id}`)
      return response.data.procedimiento
    },
    {
      enabled: !!id,
      staleTime: 5 * 60 * 1000,
    }
  )

  return {
    procedimiento: query.data,
    loading: query.isLoading,
    error: query.error,
    refetch: query.refetch
  }
}

export const useCreateProcedure = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (procedureData) => axios.post('/procedimientos', procedureData),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['procedimientos'])
      }
    }
  )
}

export const useUpdateProcedure = () => {
  const queryClient = useQueryClient()

  return useMutation(
    ({ id, data }) => axios.put(`/procedimientos/${id}`, data),
    {
      onSuccess: (response, { id }) => {
        queryClient.invalidateQueries(['procedimientos'])
        queryClient.invalidateQueries(['procedimiento', id])
      }
    }
  )
}

export const useDeleteProcedure = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (id) => axios.delete(`/procedimientos/${id}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['procedimientos'])
      }
    }
  )
}

export const useGestiones = () => {
  const query = useQuery(
    ['gestiones'],
    async () => {
      const token = localStorage.getItem('sgc_token')
      const response = await axios.get('/api/gestiones', {
        headers: { Authorization: `Bearer ${token}` }
      })
      // El endpoint retorna un array directo, no un objeto con propiedad gestiones
      return Array.isArray(response.data) ? response.data : []
    },
    {
      staleTime: 10 * 60 * 1000,
    }
  )

  return {
    gestiones: query.data || [],
    loading: query.isLoading,
    error: query.error
  }
}